"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseObjectSafe = parseObjectSafe;
exports.stringJoin = stringJoin;
exports.trimChar = trimChar;
exports.trimQuotes = trimQuotes;
exports.xc = xc;
function stringJoin(valArr) {
  var glue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var filterFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (o) {
    return !!o;
  };
  return valArr.filter(filterFn).join(glue);
}
function xc() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return stringJoin(args, ' ');
}
function trimChar(str, charToTrim) {
  return str.replace(new RegExp("^[".concat(charToTrim, "]+(.+)[").concat(charToTrim, "]+$")), '$1');
}
function trimQuotes(str) {
  return trimChar(str, '"');
}
function parseObjectSafe(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return {};
  }
}